import { render, staticRenderFns } from "./baseSquareBox.vue?vue&type=template&id=e01e412e&scoped=true"
import script from "./baseSquareBox.vue?vue&type=script&lang=js"
export * from "./baseSquareBox.vue?vue&type=script&lang=js"
import style0 from "./baseSquareBox.vue?vue&type=style&index=0&id=e01e412e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01e412e",
  null
  
)

export default component.exports